<template>
  <div data-testid="sf-fixable-container-wrapper">
    <div ref="containerToFix" data-testid="sf-fixable-container">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, watchEffect } from 'vue'

import { useTogglePositionFixed } from '@app/shared/vue/composables/use-toggle-position-fixed'

interface Props {
  fixPosition?: boolean
}

const containerToFix = ref<HTMLElement | null>(null)

const { fixPosition } = defineProps<Props>()

const isMounted = ref(false)

const { measure, setPositionFixed, resetPosition } =
  useTogglePositionFixed(containerToFix)

onMounted(() => {
  measure()
  decidePosition(fixPosition)
  isMounted.value = true

  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  resetPosition()
  isMounted.value = false

  window.removeEventListener('resize', handleResize)
})

function handleResize() {
  if (isMounted.value) {
    resetPosition()
    measure()
    decidePosition(fixPosition)
  }
}

watchEffect(() => {
  if (!isMounted.value) {
    return
  }

  decidePosition(fixPosition)
})

function decidePosition(shouldFix: boolean): void {
  if (shouldFix) {
    setPositionFixed()
  } else {
    resetPosition()
  }
}
</script>
